"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSyncSettings = exports.UpdateSyncSettingsActions = exports.UpdateSyncSettingsActionTypes = exports.loadSyncSettings = exports.FetchSyncSettingsActions = exports.FetchSyncSettingsActionTypes = exports.loadStoresStatuses = exports.FetchStoresStatusesActions = exports.FetchStoresStatusesActionTypes = exports.ShopifyActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions2 = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var ShopifyActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_STORES_STATUSES: null,
  FETCH_SYNC_SETTINGS: null,
  UPDATE_SYNC_SETTINGS: null
}, 'ecommerce-shopify-v2');
/* Stores status */

exports.ShopifyActionTypes = ShopifyActionTypes;
var FetchStoresStatusesActionTypes = (0, _actions.createRequestTypes)(ShopifyActionTypes.FETCH_STORES_STATUSES);
exports.FetchStoresStatusesActionTypes = FetchStoresStatusesActionTypes;
var FetchStoresStatusesActions = (0, _actions.createRequestActions)(FetchStoresStatusesActionTypes);
exports.FetchStoresStatusesActions = FetchStoresStatusesActions;
var loadStoresStatuses = (0, _fluxActions.createAction)(ShopifyActionTypes.FETCH_STORES_STATUSES);
exports.loadStoresStatuses = loadStoresStatuses;
var FetchSyncSettingsActionTypes = (0, _actions.createRequestTypes)(ShopifyActionTypes.FETCH_SYNC_SETTINGS);
exports.FetchSyncSettingsActionTypes = FetchSyncSettingsActionTypes;
var FetchSyncSettingsActions = (0, _actions.createRequestActions)(FetchSyncSettingsActionTypes);
exports.FetchSyncSettingsActions = FetchSyncSettingsActions;
var loadSyncSettings = (0, _fluxActions.createAction)(ShopifyActionTypes.FETCH_SYNC_SETTINGS, function (storeName) {
  return storeName;
});
exports.loadSyncSettings = loadSyncSettings;
var UpdateSyncSettingsActionTypes = (0, _actions.createRequestTypes)(ShopifyActionTypes.UPDATE_SYNC_SETTINGS);
exports.UpdateSyncSettingsActionTypes = UpdateSyncSettingsActionTypes;
var UpdateSyncSettingsActions = (0, _actions.createRequestActions)(UpdateSyncSettingsActionTypes, {
  failureMetaCreator: function failureMetaCreator(err, props) {
    return (0, _extends2.default)({}, (0, _actions2.createRequestStatusMeta)(UpdateSyncSettingsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions2.createDangerNotificationMeta)(_I18n.default.text("ecommerce.dashboard.dataSync.notify." + (props.enabled ? 'twoWay' : 'oneWay') + ".failure", {
      storeName: props.storeName
    })));
  },
  successMetaCreator: function successMetaCreator(response, props) {
    return (0, _extends2.default)({}, (0, _actions2.createRequestStatusMeta)(UpdateSyncSettingsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions2.createSuccessNotificationMeta)(_I18n.default.text("ecommerce.dashboard.dataSync.notify." + (props.enabled ? 'twoWay' : 'oneWay') + ".success", {
      storeName: props.storeName
    })));
  }
});
exports.UpdateSyncSettingsActions = UpdateSyncSettingsActions;
var updateSyncSettings = (0, _fluxActions.createAction)(ShopifyActionTypes.UPDATE_SYNC_SETTINGS, function (_ref) {
  var storeName = _ref.storeName,
      enabled = _ref.enabled;
  return {
    storeName: storeName,
    enabled: enabled
  };
});
exports.updateSyncSettings = updateSyncSettings;